import React, { Fragment } from 'react';
import { Form } from 'antd-mobile';
export default (props) => {
    const { __designMode, name, initialValue, renderAdd, renderChildren, renderHeader, onAdd } = props;
    const isDesign = __designMode === 'design';
    const render = (index) => {
        return renderChildren?.(index);
    };
    return (React.createElement(Form.Array, { name: name, initialValue: initialValue, onAdd: onAdd, renderAdd: () => renderAdd, renderHeader: (field, { add, remove, move }) => renderHeader?.(field?.index ?? 0, remove, add, move) }, (fields) => isDesign
        ? [React.createElement(Fragment, { key: 0 }, render(0))]
        : fields.map(({ index }) => React.createElement(Fragment, null, render(index)))));
};
